import vClickOutside from 'v-click-outside';
import { mapState, mapActions } from 'vuex';
const MIN_CHANNELS_TO_SHOW = 8;

// TODO: ez a modal nem igazán common, mert a pac06-nál van használva
// TODO: és tartalmaz speciálisan oda tartozó elemeket (channel megjelenítés)
// TODO: ebből is egyedi modalt kell készíteni (mint az mdl05), és a 'modal'-t meghagyni commonnak.

export default {
	directives: {
		clickOutside: vClickOutside.directive
	},
	data() {
		return {
			noChannelsToShow: MIN_CHANNELS_TO_SHOW
		}
	},
	computed: {
		showMoreChannelsButton() {
			return this.params.csatornak.length > MIN_CHANNELS_TO_SHOW && this.noChannelsToShow == MIN_CHANNELS_TO_SHOW;

		},
		...mapState('productDetailsStore', ['visible', 'params'])
	},
	methods: {
		toggle() {
			this.$store.dispatch('productDetailsStore/toggle');
			// Amikor bezárjuk a modalt, vissza kell állítani a minimálisan megjelenítendő csatorna ikonok számát.
			this.noChannelsToShow = MIN_CHANNELS_TO_SHOW;
		},
		moreChannels() {
			this.noChannelsToShow = this.params.csatornak.length;
		}
	},
}



// WEBPACK FOOTER //
// ../source/common/modal/modal.js